import React, { useEffect } from 'react'
import ContactPage from '../../components/contact_page/Contact'

function Contact() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top whenever pathname changes
  }, []);

  return (
    <>
     <ContactPage/>
    </>
  )
}

export default Contact